export default __webpack_public_path__ + "static/media/moving-truck.8cd378d8.svg";